import { render, staticRenderFns } from "./educationAdminAdd.vue?vue&type=template&id=55206171"
import script from "./educationAdminAdd.vue?vue&type=script&lang=js"
export * from "./educationAdminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55206171')) {
      api.createRecord('55206171', component.options)
    } else {
      api.reload('55206171', component.options)
    }
    module.hot.accept("./educationAdminAdd.vue?vue&type=template&id=55206171", function () {
      api.rerender('55206171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationAdminAdd.vue"
export default component.exports